import { IndeedGeneralException } from './IndeedGeneralException';

export class IndeedCandidateAlreadyContactedException extends IndeedGeneralException {
  constructor(message: string) {
    super(message);
  }
}
